import { merge } from 'lodash';
import nl from 'vee-validate/dist/locale/nl';

let customMessages = {
  dutch_postal: (field) => `Vul een geldige postcode in.`,
  dutch_phone: (field) => `Vul een geldige telefoonnummer in.`,
  iban: (field) => `Vul hier de IBAN in. Die bestaat uit uw landcode, controle getal, bankcode en uw huidige rekeningnummer aangevuld met één of meerdere nullen. Voorbeeld: NL99BANK0123456789.`,
  password: (field) => `Het ${field} moet minimaal acht karakters lang zijn, kleine en grote letters bevatten en minimaal één cijfer.`,
  minimal_age: (field) => `Fonds 1818 doneert alleen aan aanvragers boven de 16 jaar.`,
  terms: (field) => `U moet de algemene voorwaarden gelezen hebben voordat u verder kunt.`,
  kvk: (field) => `Een KvK-nummer bestaat uit acht cijfers.`,
  email: (field) => `${field} moet een bestaand e-mailadres zijn.`,
};

const messages = merge(nl.messages, customMessages);

const attributes = {
  email: 'e-mailadres',
  name: 'naam',
  gender: 'aanhef',
  initials: 'Voorletter(s)',
  lastname: 'achternaam',
  lastname_prefix: 'Tussenvoegsel(s)',
  function: 'functie',
  validAge: 'leeftijd',
  street: 'adres',
  postal: 'postcode',
  city: 'stad',
  phone: 'telefoonnummer',
  password: 'wachtwoord',
  repeatpassword: 'herhaald wachtwoord',
  terms: 'algemene voorwaarden',
  token: 'token',
  iban: 'IBAN',
  amount: 'bedrag',
  registered: 'Tenaamstelling',
  website: 'website',
  title: 'Projectnaam'
};

const locale = {
  name: 'nl',
  messages,
  attributes
};

export default locale;
